import { render } from "./student-controls.vue?vue&type=template&id=4e01c876&ts=true"
import script from "./student-controls.ts?vue&type=script&lang=ts&external"
export * from "./student-controls.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__